/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react';
import './index.scss';
import { Provider } from 'react-redux';
import store, { useAppSelector } from './../../toolkit';
import Serve from './../../serve';
import { getURLParam, reportFuc } from './../../utils';
import openApp from '@huyafed/openapp';
import { HYRouter } from '@hy-hybrid/kiwi-js-sdk';
import className from 'classnames';
declare const ClipboardJS: any;
const { openUrl, quit } = HYRouter;
const { useEffect, useState, useRef } = React;
// 是否虎牙app
// const { getAppInfo } = HYDevice
// const isHuyaApp = () => new Promise((resolve) => {
//   getAppInfo()
//     .then(resp => {
//       const APP_NAME_LIST = [
//         'hyassist4game-ios', // 手游IOS
//         'game-adr', // 手游Adr
//         'live-ios', // 助手IOS
//         'live-adr', // 助手Adr
//         'kiwi-ios', // 观众端IOS
//         'kiwi-android', // 观众端Adr
//       ]
//       console.log('getAppInfo resp', resp)
//       const isHuyaApp = APP_NAME_LIST.some(
//         (appName) => appName === resp.appName,
//       )
//       resolve(isHuyaApp)
//     })
// })
const Share = () => {
  const { isApp } = useAppSelector(state => state.base);
  const copyDom: React.MutableRefObject<any> = useRef(null);
  const [img, setImg] = useState('');
  const [name, setName] = useState('');
  const [iOld, setiOld] = useState(-1);
  useEffect(() => {
    console.log('分享页');
    // let clipboard: any = new ClipboardJS(copyDom.current)
    new ClipboardJS(copyDom.current);
    // return () => {
    // clipboard.destory()
    // clipboard = null
    // }
  }, []);
  useEffect(() => {
    reportFuc(
      'sys/pageview/ldx/outsidepage',
      '系统/页面展示/老带新/站外H5承接页曝光',
      { iType: getURLParam('iType') },
    );
    // isHuyaApp()
    //   .then(rsp => {
    //     if (rsp) {
    //       openUrl({
    //         url: `https://m.huya.com/?hyaction=acceptolduserinvite&lInvUid=${getURLParam('uid')}&iType=${getURLParam('iType')}`,
    //       })
    //       quit()
    //     }
    //   })
    if (isApp) {
      openUrl({
        url: `https://m.huya.com/?hyaction=acceptolduserinvite&lInvUid=${getURLParam(
          'uid',
        )}&iType=${getURLParam('iType')}`,
      });
      quit();
    } else {
      Serve.getUserProfile(
        parseInt(getURLParam('uid') as string, 10) || 0,
      ).then(rsp => {
        console.log('getUserProfile', rsp);
        setImg(rsp.data.tUserProfile.tUserBase.sAvatarUrl);
        setName(rsp.data.tUserProfile.tUserBase.sNickName);
      });
    }
    Serve.getOld(parseInt(getURLParam('uid') as string, 10) || 0).then(
      rsp => {
        // console.log('rsp', rsp)
        // const resp = rsp.data
        setiOld(1);

        console.log(iOld);
      },
    );
  }, [isApp]);
  return (
    <div className={`share-cover ${isApp ? 'isApp' : 'outApp'}`}>
      <div className="cash-icon"></div>
      {
        <div
          id="share-image"
          className={className('share-image', {
            new: iOld === 1,
            old: iOld === 0,
          })}
        >
          <div className="share-avatar">
            {img !== '' && (
              <img
                src={img}
                alt={name}
                onError={(event: any): void => {
                  event.target.onerror = null;
                  event.target.src =
                    'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                }}
              />
            )}
            <i />
          </div>
          {iOld === 1 && <p className="desc">接受我邀请，登录虎牙直播App</p>}
          <div
            ref={copyDom}
            className="share-btn"
            data-clipboard-text={'#' + getURLParam('code') + '# $1 s@o.t'}
            onClick={() => {
              reportFuc(
                'usr/click/ldx/outsidepage/jump',
                '用户/点击/老带新/站外H5/承接页跳转按钮点击',
                {},
              );
              openApp({
                appAction: `hyaction=acceptolduserinvite&lInvUid=${getURLParam(
                  'uid',
                )}&iType=${getURLParam('iType')}`,
                key: 'ldx',
              });
            }}
          />
          {/* <p className="share-bottom-desc">
            首次登录虎牙直播app，即可无门槛领取微信零钱
          </p>
          <div className="share-bottom" /> */}
        </div>
      }
    </div>
  );
};

export default (): React.ReactNode => (
  <Provider store={store}>
    <Share />
  </Provider>
);
